export default state => state.expressCheckout.usingExpressCheckout;
